import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { PageLayout } from '@/components/templates/PageLayout';
import { CmCard, CmLabelAndSelect, CmStack } from '@/components/uiParts';
import { redirect404Page } from '@/lib/AccessControl';
import { LocalStorageHandler } from '@/lib/LocalStorageHandler';
import { routes } from '@/router';
import { useManagerAccountMe } from '@/services/AuthEnterprise/hooks';
import { useEnterprise } from '@/services/Enterprise/hooks';

import { PosItemsArea } from './components/PosItemsArea';

const PosConnectPage: React.FC = () => {
  const { enterprise } = useEnterprise();
  const { managerAccountMe } = useManagerAccountMe();
  const history = useHistory();
  /* アクセス制御 */
  redirect404Page('associate_with_pos_system', history, managerAccountMe);

  const posProviders = enterprise?.providers || [];
  const [selectedPosProvider, setSelectedPosProvider] = useState<string>('');

  const handleSelectPosProvider: React.ChangeEventHandler<HTMLSelectElement> = (
    e
  ) => {
    const posProviderName = e.target.value as string;
    setSelectedPosProvider(posProviderName);
  };

  useEffect(() => {
    // NOTE: 仕様：posProviderが一つしかない場合は選択してテーブルを先に表示させる。
    if (posProviders.length === 1) {
      setSelectedPosProvider(posProviders[0].provider_name);
    }
  }, [enterprise]);

  useEffect(() => {
    return () => LocalStorageHandler.removeItem('draft_pos_data');
  }, []);

  return (
    <PageLayout title={routes.PosConnect.title}>
      <CmStack spacing={3} my={5}>
        {posProviders.length >= 2 && (
          <CmCard>
            <CmLabelAndSelect
              selectWidth="300px"
              placeholder="選択してください"
              label="ご利用の POS事業者 を選択してください"
              onChange={handleSelectPosProvider}
              value={selectedPosProvider}
            >
              {posProviders.map((posProvider) => (
                <option
                  value={posProvider.provider_name}
                  key={posProvider.provider_id}
                >
                  {posProvider.provider_name}
                </option>
              ))}
            </CmLabelAndSelect>
          </CmCard>
        )}
        {selectedPosProvider !== '' && (
          <PosItemsArea {...{ selectedPosProvider }} />
        )}
      </CmStack>
    </PageLayout>
  );
};

export default PosConnectPage;
